webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_home_component__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_home_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_home_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about_about_component__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_about_about_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_about_about_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_work_work_component__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_work_work_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_work_work_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_legal_legal_component__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_legal_legal_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_legal_legal_component__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home_home_component___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__components_about_about_component___default.a
  }, {
    path: '/work',
    name: 'work',
    component: __WEBPACK_IMPORTED_MODULE_4__components_work_work_component___default.a
  }, {
    path: '/legal',
    name: 'legal',
    component: __WEBPACK_IMPORTED_MODULE_5__components_legal_legal_component___default.a
  }],
  mode: 'history'
}));

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(38),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_App_Component__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_app_App_Component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_app_App_Component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(13);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    english: true
  },
  getters: {
    english: function english(state) {
      return state.english;
    }
  },
  mutations: {
    selectEn: function selectEn(state) {
      state.english = true;
    },
    selectDe: function selectDe(state) {
      state.english = false;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__components_app_App_Component___default.a
  },
  store: store
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  data: function data() {
    return {
      about: true,
      design: false,
      dev: false,
      pwa: false
    };
  },
  computed: {
    english: function english() {
      return this.$store.getters.english;
    }
  },
  mounted: function mounted() {
    if (window.innerWidth > 900) {
      __WEBPACK_IMPORTED_MODULE_0_gsap__["b" /* TweenMax */].to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0, {
        opacity: 0,
        transform: 'translateX(20px)',
        display: 'none'
      });
    }
  },
  methods: {
    designClicked: function designClicked() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.dev, this.$refs.pwa, this.$refs.about], 0.4, {
        opacity: 0,
        transform: 'translateX(-20px)',
        display: 'none'
      }).to(this.$refs.design, 0.4, {
        opacity: 1,
        transform: 'translateX(0)',
        display: 'block'
      }).to([this.$refs.dev, this.$refs.pwa, this.$refs.about], 0.4, {
        transform: 'translateX(20px)'
      });
      tl.play();
      this.about = false;
      this.design = true;
      this.dev = false;
      this.pwa = false;
    },
    devClicked: function devClicked() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.design, this.$refs.pwa, this.$refs.about], 0.4, {
        opacity: 0,
        transform: 'translateX(-20px)',
        display: 'none'
      }).to(this.$refs.dev, 0.4, {
        opacity: 1,
        transform: 'translateX(0)',
        display: 'block'
      }).to([this.$refs.design, this.$refs.pwa, this.$refs.about], 0.4, {
        transform: 'translateX(20px)'
      });
      tl.play();
      this.about = false;
      this.design = false;
      this.dev = true;
      this.pwa = false;
    },
    pwaClicked: function pwaClicked() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.design, this.$refs.dev, this.$refs.about], 0.4, {
        opacity: 0,
        transform: 'translateX(-20px)',
        display: 'none'
      }).to(this.$refs.pwa, 0.4, {
        opacity: 1,
        transform: 'translateX(0)',
        display: 'block'
      }).to([this.$refs.design, this.$refs.dev, this.$refs.about], 0.4, {
        transform: 'translateX(20px)'
      });
      tl.play();
      this.about = false;
      this.design = false;
      this.dev = false;
      this.pwa = true;
    },
    aboutClicked: function aboutClicked() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0.4, {
        opacity: 0,
        transform: 'translateX(-20px)',
        display: 'none'
      }).to(this.$refs.about, 0.4, {
        opacity: 1,
        transform: 'translateX(0)',
        display: 'block'
      }).to([this.$refs.design, this.$refs.dev, this.$refs.pwa], 0.4, {
        transform: 'translateX(20px)'
      });
      tl.play();
      this.about = true;
      this.design = false;
      this.dev = false;
      this.pwa = false;
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      comp: {},
      menu: false,
      isWork: false,
      isHome: false,
      lastScroll: 0
    };
  },
  computed: {
    english: function english() {
      return this.$store.getters.english;
    }
  },
  beforeMounted: function beforeMounted() {
    this.comp = this.$refs.view;
    if (this.$route.name === 'work') {
      this.isWork = true;
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
        display: 'block',
        opacity: 1
      }).to([this.$refs.navi, this.$refs.lang], 0, {
        opacity: 0,
        transform: 'translateX(-60px)'
      });
      tl.play();
    }

    if (window.addEventListener) {
      window.addEventListener('mousewheel', this.handleScroll, false);
      window.addEventListener('DOMMouseScroll', this.handleScroll, false);
    } else {
      window.attachEvent('onmousewheel', this.handleScroll);
    }
  },
  mounted: function mounted() {
    this.comp = this.$refs.view;
    if (this.$route.name === 'work') {
      this.isWork = true;
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
        display: 'block',
        opacity: 1
      }).to([this.$refs.navi, this.$refs.lang], 0, {
        opacity: 0,
        transform: 'translateX(-60px)'
      });
      tl.play();
    }

    if (window.addEventListener) {
      window.addEventListener('mousewheel', this.handleScroll, false);
      window.addEventListener('DOMMouseScroll', this.handleScroll, false);
    } else {
      window.attachEvent('onmousewheel', this.handleScroll);
    }
  },
  methods: {
    handleScroll: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.throttle(function (e) {

      if (Date.now() - this.lastScroll > 2200) {
        if (window.innerWidth > 900) {
          var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
          if (this.$route.name === 'home') {
            if (delta === -1) {
              this.$router.push('work');
              this.isWork = true;
              var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
                paused: true
              });
              tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
                opacity: 0,
                transform: 'translateX(-60px)'
              }).to([this.$refs.navi, this.$refs.lang], 0, {
                opacity: 0,
                transform: 'translateX(-100vw)'
              }).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                display: 'block',
                opacity: 0,
                transform: 'translateX(60px)'
              }).staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                opacity: 1,
                transform: 'translateX(0)'
              }, 0.05);
              tl.play();
            }
          } else if (this.$route.name === 'work') {
            if (delta === -1) {
              this.$router.push('about');
              this.isWork = false;
              var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
                paused: true
              });
              tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                opacity: 0,
                transform: 'translateX(60px)'
              }, 0.05).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                display: 'none'
              }).to([this.$refs.navi, this.$refs.lang], 0.55, {
                opacity: 0,
                transform: 'translateX(-60px)'
              }).to([this.$refs.navi, this.$refs.lang], 0.5, {
                opacity: 1,
                transform: 'translateX(0px)'
              });
              tl.play();
            } else if (delta === 1) {
              this.$router.push('/');
              this.isWork = false;
              var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
                paused: true
              });
              tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                opacity: 0,
                transform: 'translateX(60px)'
              }, 0.05).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                display: 'none'
              }).to([this.$refs.navi, this.$refs.lang], 0.55, {
                opacity: 0,
                transform: 'translateX(-60px)'
              }).to([this.$refs.navi, this.$refs.lang], 0.5, {
                opacity: 1,
                transform: 'translateX(0px)'
              });
              tl.play();
            }
          } else if (this.$route.name === 'about') {
            if (delta === 1) {
              if (document.documentElement.scrollTop === 0 && Date.now() - this.lastScroll > 2000) {
                this.$router.push('work');
                this.isWork = true;
                var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
                  paused: true
                });
                tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
                  opacity: 0,
                  transform: 'translateX(-60px)'
                }).to([this.$refs.navi, this.$refs.lang], 0, {
                  opacity: 0,
                  transform: 'translateX(-100vw)'
                }).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
                  display: 'block',
                  opacity: 0,
                  transform: 'translateX(60px)'
                }).staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
                  opacity: 1,
                  transform: 'translateX(0)'
                }, 0.05);
                tl.play();
              }
            }
          }
        }
        this.lastScroll = Date.now();
      }
    }, 1000),
    toggleEn: function toggleEn() {
      this.$store.commit('selectEn');
    },
    toggleDe: function toggleDe() {
      this.$store.commit('selectDe');
    },
    workMenuClicked: function workMenuClicked() {
      if (window.innerWidth > 900) {
        this.menu = !this.menu;
        var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
          paused: true
        });
        if (this.menu) {
          tl.to([this.$refs.workNavi], 0, {
            transform: 'translateY(-10px)',
            display: 'none'
          }).to([this.$refs.workNavi], 0.5, {
            display: 'block',
            opacity: 1,
            transform: 'translateY(0px)'
          });
          tl.play();
        } else {
          tl.to([this.$refs.workNavi], 0.5, {
            opacity: 0,
            transform: 'translateY(-10px)',
            display: 'none'
          });
          tl.play();
        }
      }
    },
    workLinkClicked: function workLinkClicked() {
      if (window.innerWidth > 900) {
        this.menu = !this.menu;
        var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
          paused: true
        });
        if (this.menu) {
          tl.to([this.$refs.workNavi], 0, {
            transform: 'translateY(-10px)',
            display: 'none'
          }).to([this.$refs.workNavi], 0.5, {
            display: 'block',
            opacity: 1,
            transform: 'translateY(0px)'
          });
          tl.play();
        } else {
          tl.to([this.$refs.workNavi], 0.5, {
            opacity: 0,
            transform: 'translateY(-10px)',
            display: 'none'
          });
          tl.play();
          this.menuClicked();
        }
      }
    },
    menuClicked: function menuClicked() {
      if (window.innerWidth < 900) {
        this.menu = !this.menu;
        var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
          paused: true
        });
        tl.from(this.$refs.menu, 0.1, {
          opacity: 0
        }).from(this.$refs.link1, 0.25, {
          opacity: 0,
          transform: 'translateY(-20px)'
        }, 0.1).from(this.$refs.link2, 0.25, {
          opacity: 0,
          transform: 'translateY(-20px)'
        }, 0.125).from(this.$refs.link3, 0.25, {
          opacity: 0,
          transform: 'translateY(-20px)'
        }, 0.15).from(this.$refs.fb, 0.2, {
          opacity: 0,
          transform: 'translateX(-10px)'
        }, 0.25).from(this.$refs.twitter, 0.2, {
          opacity: 0,
          transform: 'translateX(-10px)'
        }, 0.3).from(this.$refs.dribbble, 0.2, {
          opacity: 0,
          transform: 'translateX(-10px)'
        }, 0.35).from(this.$refs.language, 0.2, {
          opacity: 0,
          transform: 'translateX(-10px)'
        }, 0.35);
        tl.play();
      } else {
        if (this.$route.name === 'work') {
          this.isHome = false;
          this.isWork = true;
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.to([this.$refs.navi, this.$refs.lang], 0.4, {
            opacity: 0,
            transform: 'translateX(-60px)'
          }).to([this.$refs.navi, this.$refs.lang], 0, {
            opacity: 0,
            transform: 'translateX(-100vw)'
          }).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
            display: 'block',
            opacity: 0,
            transform: 'translateX(60px)'
          }).staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
            opacity: 1,
            transform: 'translateX(0)'
          }, 0.05);
          tl.play();
        } else if (this.isWork) {
          this.isWork = false;
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.staggerTo([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0.1, {
            opacity: 0,
            transform: 'translateX(60px)'
          }, 0.05).to([this.$refs.line1, this.$refs.line2, this.$refs.line3, this.$refs.clicker], 0, {
            display: 'none'
          }).to([this.$refs.navi, this.$refs.lang], 0.55, {
            opacity: 0,
            transform: 'translateX(-60px)'
          }).to([this.$refs.navi, this.$refs.lang], 0.5, {
            opacity: 1,
            transform: 'translateX(0px)'
          });
          tl.play();
        }
      }
    },
    enter: function enter() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      if (this.$route.name === 'home') {
        tl.to([this.$refs.view.$refs.object1, this.$refs.view.$refs.object2, this.$refs.view.$refs.object3], 0, {
          opacity: 0,
          transform: 'translateY(20px)'
        }).to(this.$refs.view.$refs.object4, 0, {
          opacity: 0
        }).to(this.$refs.rectangle, 0, {
          transform: 'scaleX(0)',
          ease: Power1.easeIn
        });
      } else {
        tl.to([this.$refs.view.$refs.object1, this.$refs.view.$refs.object2, this.$refs.view.$refs.object3], 0, {
          opacity: 0,
          transform: 'translateY(20px)'
        }).to(this.$refs.view.$refs.object4, 0, {
          opacity: 0
        });
      }

      tl.play();
    },
    afterEnter: function afterEnter() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      if (this.$route.name === 'home') {
        tl.to(this.$refs.view.$refs.object1, 0.4, {
          opacity: 1,
          transform: 'translateY(0px)'
        }).to(this.$refs.view.$refs.object2, 0.3, {
          opacity: 1,
          transform: 'translateY(0px)'
        }, 0.3).to(this.$refs.view.$refs.object3, 0.3, {
          opacity: 1,
          transform: 'translateY(0px)'
        }).to(this.$refs.view.$refs.object4, 0.2, {
          opacity: 1
        }, 0.1).to(this.$refs.rectangle, 0.5, {
          transform: 'scaleX(1)',
          ease: Power1.easeOut
        }, 0.1);
      } else {
        tl.to(this.$refs.view.$refs.object1, 0.4, {
          opacity: 1,
          transform: 'translateY(0px)'
        }).to(this.$refs.view.$refs.object2, 0.3, {
          opacity: 1,
          transform: 'translateY(0px)'
        }, 0.3).to(this.$refs.view.$refs.object3, 0.3, {
          opacity: 1,
          transform: 'translateY(0px)'
        }).to(this.$refs.view.$refs.object4, 0.2, {
          opacity: 1
        }, 0.1);
      }
      tl.play();
      this.comp = this.$refs.view;
    },
    leave: function leave() {
      var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tl.to(this.$refs.rectangle, 0.4, {
        transform: 'scaleX(0)',
        ease: Power1.easeIn
      }).to(this.comp.$refs.object1, 0.4, {
        opacity: 0,
        transform: 'translateY(-20px)'
      }).to(this.comp.$refs.object2, 0.3, {
        opacity: 0,
        transform: 'translateY(-20px)'
      }, 0.2).to(this.comp.$refs.object3, 0.3, {
        opacity: 0,
        transform: 'translateY(-20px)'
      }, 0.4).to(this.comp.$refs.object4, 0.2, {
        opacity: 0
      }, 0.7);

      var tt = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
        paused: true
      });
      tt.to(this.$refs.rectangle, 0.4, {
        transform: 'scaleX(0)',
        ease: Power1.easeIn
      });
      tt.play();
      tl.play();
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      activeB: true
    };
  },
  components: {},
  mounted: function mounted() {
    var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
      paused: true,
      onComplete: function onComplete() {
        this.restart();
      }
    });
    tl.to(this.$refs.mouseWheel, 0, {
      opacity: 0,
      y: '-3px'
    }).to(this.$refs.mouseWheel, 0.3, {
      opacity: 1,
      y: '0px'
    }).fromTo(this.$refs.mouseWheel, 1.8, {
      y: '0px'
    }, {
      y: '6px'
    }, 0).to(this.$refs.mouseWheel, 0.3, {
      opacity: 0
    }, 1.2);
    tl.play();
  },
  computed: {
    english: function english() {
      return this.$store.getters.english;
    }
  },
  methods: {}
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work',
  data: function data() {
    return {
      pNumber: 0,
      projects: [{
        category: 'Website',
        title: 'goTama',
        enContent: 'goTama strives to become a new standard for studying at universities. The challenge for this website was to let visitors understand the unique selling points of the web app.',
        deContent: 'Die App goTama möchte einen neuen Lernstandard an Universitäten setzen. Die Herausforderung bei der Entwicklung ihrer Webseite war es, Besuchern perfekt die Vorteile von goTama zu vermitteln.',
        url: 'http://gotama.rocks'
      }, {
        category: 'Website',
        title: 'Bistro Thang Long',
        enContent: 'Together with the owners of this fine little restaurant located in Bernburg we created a new website. We dedicated special attention to the menu of the restaurant to give it a unique touch.',
        deContent: 'Zusammen mit den Besitzern dieses kleinen, feinen Restaurants entwickelten wir eine neue Webseite. Besonderen Fokus setzten wir hierbei auf das Speisemenü um es von anderen Restaurantseiten abzuheben.',
        url: 'http://bistro-thanglong.de/'
      }, {
        category: 'Wordpress',
        title: 'Sei Dir Selbstbewusst',
        enContent: 'Laura Wällnitz is a remarkable motivation trainer and speaker. Together with her we worked on her personal branding and created this wordpress powered personal site and blog.',
        deContent: 'Laura Wällnitz ist eine herausragende Motivationstrainerin und Sprecherin. Wir arbeiteten mit ihr zusammen an ihrer persönlichen Marke und entwickelten ihre Wordpress Seite.',
        url: 'http://seidirselbstbewusst.com/'
      }]
    };
  },
  computed: {
    english: function english() {
      return this.$store.getters.english;
    }
  },
  methods: {
    next: function next() {
      var _this = this;

      if (window.innerWidth < 900) {
        if (this.pNumber < 2) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(-100vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(100vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this.pNumber++;
          }, 600);
        }
      } else {
        if (this.pNumber < 2) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(-50vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(50vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();
          setTimeout(function () {
            return _this.pNumber++;
          }, 600);
        }
      }
    },
    prev: function prev() {
      var _this2 = this;

      if (window.innerWidth < 900) {
        if (this.pNumber > 0) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(-100vw)'
          }).staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(100vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(100vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(-30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this2.pNumber--;
          }, 600);
        }
      } else {
        if (this.pNumber > 0) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(-50vw)'
          }).staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(50vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(50vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(-30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this2.pNumber--;
          }, 600);
        }
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'work',
  data: function data() {
    return {
      pNumber: 0,
      projects: [{
        category: 'Website',
        title: 'goTama',
        enContent: 'goTama strives to become a new standard for studying at universities. The challenge for this website was to let visitors understand the unique selling points of the web app.',
        deContent: 'Die App goTama möchte einen neuen Lernstandard an Universitäten setzen. Die Herausforderung bei der Entwicklung ihrer Webseite war es, Besuchern perfekt die Vorteile von goTama zu vermitteln.',
        url: 'http://gotama.rocks'
      }, {
        category: 'Website',
        title: 'Bistro Thang Long',
        enContent: 'Together with the owners of this fine little restaurant located in Bernburg we created a new website. We dedicated special attention to the menu of the restaurant to give it a unique touch.',
        deContent: 'Zusammen mit den Besitzern dieses kleinen, feinen Restaurants entwickelten wir eine neue Webseite. Besonderen Fokus setzten wir hierbei auf das Speisemenü um es von anderen Restaurantseiten abzuheben.',
        url: 'http://bistro-thanglong.de/'
      }, {
        category: 'Wordpress',
        title: 'Sei Dir Selbstbewusst',
        enContent: 'Laura Wällnitz is a remarkable motivation trainer and speaker. Together with her we worked on her personal branding and created this wordpress powered personal site and blog.',
        deContent: 'Laura Wällnitz ist eine herausragende Motivationstrainerin und Sprecherin. Wir arbeiteten mit ihr zusammen an ihrer persönlichen Marke und entwickelten ihre Wordpress Seite.',
        url: 'http://seidirselbstbewusst.com/'
      }]
    };
  },
  computed: {
    english: function english() {
      return this.$store.getters.english;
    }
  },
  methods: {
    next: function next() {
      var _this = this;

      if (window.innerWidth < 900) {
        if (this.pNumber < 2) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(-100vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(100vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this.pNumber++;
          }, 600);
        }
      } else {
        if (this.pNumber < 2) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(-50vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(50vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(-30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();
          setTimeout(function () {
            return _this.pNumber++;
          }, 600);
        }
      }
    },
    prev: function prev() {
      var _this2 = this;

      if (window.innerWidth < 900) {
        if (this.pNumber > 0) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(-100vw)'
          }).staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(100vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(100vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(-30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this2.pNumber--;
          }, 600);
        }
      } else {
        if (this.pNumber > 0) {
          var tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["a" /* TimelineLite */]({
            paused: true
          });
          tl.to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(-50vw)'
          }).staggerTo([this.$refs.blend1, this.$refs.blend4, this.$refs.blend2, this.$refs.blend5, this.$refs.blend3], 0.3, {
            transform: 'translateX(0)',
            ease: Power1.easeOut
          }, 0.1).staggerTo([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0.3, {
            transform: 'translateX(50vw)',
            ease: Power1.easeOut
          }, 0.1).to([this.$refs.blend3, this.$refs.blend5, this.$refs.blend1, this.$refs.blend4, this.$refs.blend2], 0, {
            transform: 'translateX(50vw)'
          }).to([this.$refs.object1], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.1).to([this.$refs.object2], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.3).to([this.$refs.object3], 0.3, {
            transform: 'translateX(30px)',
            opacity: 0,
            ease: Power1.easeIn
          }, 0.4).to([this.$refs.object1, this.$refs.object2, this.$refs.object3], 0, {
            transform: 'translateX(-30px)',
            opacity: 0
          }, 0.5).to([this.$refs.object1], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.6).to([this.$refs.object2], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.8).to([this.$refs.object3], 0.3, {
            transform: 'translateX(0)',
            opacity: 1,
            ease: Power1.easeOut
          }, 0.9);
          tl.play();

          setTimeout(function () {
            return _this2.pNumber--;
          }, 600);
        }
      }
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e837415",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(39),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5b8a5b19",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(41),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6f66b126",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(40),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68c43a59",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutContent"
  }, [_c('div', {
    ref: "object4"
  }, [_c('div', {
    staticClass: "aboutBG"
  }, [_c('svg', {
    attrs: {
      "width": "599px",
      "height": "364px",
      "viewBox": "0 0 599 364",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("ABOUT US")]), _vm._v(" "), _c('desc', [_vm._v("About Us Background Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "About-us",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-91.000000, -122.000000)",
      "opacity": "0.299999982"
    }
  }, [_c('path', {
    attrs: {
      "d": "M154.94,158.04 L143.72,224.7 L166.6,224.7 L155.38,158.04 L154.94,158.04 Z M180.9,125.92 L219.18,283 L175.62,283 L171.44,255.5 L138.88,255.5 L134.7,283 L91.8,283 L129.42,125.92 L180.9,125.92 Z M268.24,253.52 L279.68,253.52 C283.493352,253.52 286.866652,251.943349 289.8,248.79 C292.733348,245.636651 294.2,240.760033 294.2,234.16 C294.2,227.999969 292.733348,223.306683 289.8,220.08 C286.866652,216.853317 283.493352,215.24 279.68,215.24 L268.24,215.24 L268.24,253.52 Z M268.24,187.52 L278.14,187.52 C282.393355,187.52 285.619989,185.943349 287.82,182.79 C290.020011,179.636651 291.12,175.933355 291.12,171.68 C291.12,167.279978 290.020011,163.466683 287.82,160.24 C285.619989,157.013317 282.393355,155.4 278.14,155.4 L268.24,155.4 L268.24,187.52 Z M227.32,125.92 L289.14,125.92 C303.80674,125.92 314.623299,129.476631 321.59,136.59 C328.556702,143.703369 332.04,153.199941 332.04,165.08 C332.04,169.186687 331.563338,173.183314 330.61,177.07 C329.656662,180.956686 328.19001,184.476651 326.21,187.63 C324.22999,190.783349 321.700015,193.459989 318.62,195.66 C315.539985,197.860011 311.800022,199.399996 307.4,200.28 L307.4,200.72 C312.533359,201.160002 316.933315,202.516655 320.6,204.79 C324.266685,207.063345 327.273322,209.88665 329.62,213.26 C331.966678,216.63335 333.689995,220.336646 334.79,224.37 C335.890006,228.403354 336.44,232.473313 336.44,236.58 C336.44,243.3267 335.560009,249.559971 333.8,255.28 C332.039991,261.000029 329.290019,265.913313 325.55,270.02 C321.809981,274.126687 316.933363,277.316655 310.92,279.59 C304.906637,281.863345 297.646709,283 289.14,283 L227.32,283 L227.32,125.92 Z M389.9,204.46 C389.9,215.020053 390.046665,223.783299 390.34,230.75 C390.633335,237.716701 391.256662,243.253313 392.21,247.36 C393.163338,251.466687 394.556658,254.326659 396.39,255.94 C398.223343,257.553341 400.679985,258.36 403.76,258.36 C406.840015,258.36 409.296657,257.553341 411.13,255.94 C412.963343,254.326659 414.356662,251.466687 415.31,247.36 C416.263338,243.253313 416.886665,237.716701 417.18,230.75 C417.473335,223.783299 417.62,215.020053 417.62,204.46 C417.62,193.899947 417.473335,185.136702 417.18,178.17 C416.886665,171.203299 416.263338,165.666687 415.31,161.56 C414.356662,157.453313 412.963343,154.593341 411.13,152.98 C409.296657,151.366659 406.840015,150.56 403.76,150.56 C400.679985,150.56 398.223343,151.366659 396.39,152.98 C394.556658,154.593341 393.163338,157.453313 392.21,161.56 C391.256662,165.666687 390.633335,171.203299 390.34,178.17 C390.046665,185.136702 389.9,193.899947 389.9,204.46 Z M347.66,204.46 C347.66,189.79326 348.613324,177.290052 350.52,166.95 C352.426676,156.609948 355.579978,148.176699 359.98,141.65 C364.380022,135.123301 370.173297,130.356682 377.36,127.35 C384.546703,124.343318 393.346615,122.84 403.76,122.84 C414.173385,122.84 422.973297,124.343318 430.16,127.35 C437.346703,130.356682 443.139978,135.123301 447.54,141.65 C451.940022,148.176699 455.093324,156.609948 457,166.95 C458.906676,177.290052 459.86,189.79326 459.86,204.46 C459.86,219.12674 458.906676,231.629948 457,241.97 C455.093324,252.310052 451.940022,260.743301 447.54,267.27 C443.139978,273.796699 437.346703,278.453319 430.16,281.24 C422.973297,284.026681 414.173385,285.42 403.76,285.42 C393.346615,285.42 384.546703,284.026681 377.36,281.24 C370.173297,278.453319 364.380022,273.796699 359.98,267.27 C355.579978,260.743301 352.426676,252.310052 350.52,241.97 C348.613324,231.629948 347.66,219.12674 347.66,204.46 Z M513.76,125.92 L513.76,239.22 C513.76,246.846705 514.859989,251.943321 517.06,254.51 C519.260011,257.07668 522.266648,258.36 526.08,258.36 C529.893352,258.36 532.899989,257.07668 535.1,254.51 C537.300011,251.943321 538.4,246.846705 538.4,239.22 L538.4,125.92 L579.32,125.92 L579.32,228.88 C579.32,239.880055 578.146678,249.04663 575.8,256.38 C573.453322,263.71337 570.043356,269.579978 565.57,273.98 C561.096644,278.380022 555.560033,281.386659 548.96,283 C542.359967,284.613341 534.733377,285.42 526.08,285.42 C517.573291,285.42 509.983367,284.613341 503.31,283 C496.636633,281.386659 491.063356,278.380022 486.59,273.98 C482.116644,269.579978 478.706678,263.71337 476.36,256.38 C474.013322,249.04663 472.84,239.880055 472.84,228.88 L472.84,125.92 L513.76,125.92 Z M617.6,160.68 L587.24,160.68 L587.24,125.92 L689.32,125.92 L689.32,160.68 L658.52,160.68 L658.52,283 L617.6,283 L617.6,160.68 Z M142.84,325.92 L142.84,439.22 C142.84,446.846705 143.939989,451.943321 146.14,454.51 C148.340011,457.076679 151.346648,458.36 155.16,458.36 C158.973352,458.36 161.979989,457.076679 164.18,454.51 C166.380011,451.943321 167.48,446.846705 167.48,439.22 L167.48,325.92 L208.4,325.92 L208.4,428.88 C208.4,439.880055 207.226678,449.04663 204.88,456.38 C202.533322,463.71337 199.123356,469.579978 194.65,473.98 C190.176644,478.380022 184.640033,481.386659 178.04,483 C171.439967,484.613341 163.813377,485.42 155.16,485.42 C146.653291,485.42 139.063367,484.613341 132.39,483 C125.716633,481.386659 120.143356,478.380022 115.67,473.98 C111.196644,469.579978 107.786678,463.71337 105.44,456.38 C103.093322,449.04663 101.92,439.880055 101.92,428.88 L101.92,325.92 L142.84,325.92 Z M287.16,371.24 L287.16,367.5 C287.16,362.806643 286.206676,358.810016 284.3,355.51 C282.393324,352.209984 279.46002,350.56 275.5,350.56 C271.099978,350.56 267.873344,351.989986 265.82,354.85 C263.766656,357.710014 262.74,360.899982 262.74,364.42 C262.74,369.553359 264.389983,373.623318 267.69,376.63 C270.990017,379.636682 275.133308,382.239989 280.12,384.44 C285.106692,386.640011 290.459971,388.876655 296.18,391.15 C301.900029,393.423345 307.253308,396.393315 312.24,400.06 C317.226692,403.726685 321.369984,408.52997 324.67,414.47 C327.970016,420.41003 329.62,428.146619 329.62,437.68 C329.62,454.400084 324.853381,466.536629 315.32,474.09 C305.786619,481.643371 292.00009,485.42 273.96,485.42 C265.453291,485.42 257.936699,484.72334 251.41,483.33 C244.883301,481.93666 239.383356,479.516684 234.91,476.07 C230.436644,472.623316 227.026678,468.113361 224.68,462.54 C222.333322,456.966639 221.16,450.073374 221.16,441.86 L221.16,436.36 L260.76,436.36 L260.76,440.1 C260.76,446.8467 262.006654,451.576653 264.5,454.29 C266.993346,457.003347 270.21998,458.36 274.18,458.36 C278.433355,458.36 281.696655,456.893348 283.97,453.96 C286.243345,451.026652 287.38,447.433355 287.38,443.18 C287.38,438.046641 285.803349,433.976682 282.65,430.97 C279.496651,427.963318 275.536691,425.396677 270.77,423.27 C266.00331,421.143323 260.833361,418.980011 255.26,416.78 C249.686639,414.579989 244.51669,411.720018 239.75,408.2 C234.98331,404.679982 231.023349,400.060029 227.87,394.34 C224.716651,388.619971 223.14,381.140046 223.14,371.9 C223.14,355.913253 227.393291,343.740042 235.9,335.38 C244.406709,327.019958 257.313247,322.84 274.62,322.84 C292.513423,322.84 305.456627,326.689961 313.45,334.39 C321.443373,342.090038 325.44,354.373249 325.44,371.24 L287.16,371.24 Z",
      "id": "ABOUT-US",
      "fill": "#F4F5F5"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "vertLine"
  })]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    ref: "object1",
    staticClass: "heading"
  }, [(_vm.english) ? _c('h1', {
    on: {
      "click": _vm.aboutClicked
    }
  }, [_vm._v("About Us")]) : _c('h1', {
    on: {
      "click": _vm.aboutClicked
    }
  }, [_vm._v("Über uns")]), _vm._v(" "), (_vm.english) ? _c('div', {
    ref: "object2",
    staticClass: "further"
  }, [_c('h3', {
    class: {
      active: _vm.design
    },
    on: {
      "click": _vm.designClicked
    }
  }, [_vm._v("Design")]), _vm._v(" "), _c('h3', {
    class: {
      active: _vm.dev
    },
    on: {
      "click": _vm.devClicked
    }
  }, [_vm._v("Development")]), _vm._v(" "), _c('h3', {
    class: {
      active: _vm.pwa
    },
    on: {
      "click": _vm.pwaClicked
    }
  }, [_vm._v("PWA")])]) : _c('div', {
    ref: "object2",
    staticClass: "further"
  }, [_c('h3', {
    class: {
      active: _vm.design
    },
    on: {
      "click": _vm.designClicked
    }
  }, [_vm._v("Design")]), _vm._v(" "), _c('h3', {
    class: {
      active: _vm.dev
    },
    on: {
      "click": _vm.devClicked
    }
  }, [_vm._v("Entwicklung")]), _vm._v(" "), _c('h3', {
    class: {
      active: _vm.pwa
    },
    on: {
      "click": _vm.pwaClicked
    }
  }, [_vm._v("PWA")])])]), _vm._v(" "), _c('div', {
    ref: "object3",
    staticClass: "container"
  }, [_c('div', {
    ref: "about",
    staticClass: "content"
  }, [(_vm.english) ? _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("We know you are awesome at what you do... But is your website showing that?")]), _vm._v(" "), _c('p', [_vm._v("\n                Do you want to launch a new product, business or service?\n                Do you want to refine your online presence to better reflect what you do?\n                Do you want to showcase your unique personality and authority in your industry?\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                Then we can use our experience in building websites where we blend professional design with measurable business results.\n                We craft every website to match each client’s personality, brand and audience.\n              ")])]) : _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("Sie haben großartige Fähigkeiten... Aber zeigt Ihre Webseite das auch?")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n                Dann möchten wir mit unserer Erfahrung im Webseitenbau, bei welchem wir professionelles Design mit messbaren Ergebnissen verbinden, Ihnen gerne helfen.\n                Wir versuchen bei jeder Seite, die wir entwickeln, die Persönlichkeit, Marke und die Zielgruppe des Klienten widerzuspiegeln.\n              ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    ref: "design",
    staticClass: "content"
  }, [(_vm.english) ? _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("Doing the first steps together - Conception and Consulting")]), _vm._v(" "), _c('p', [_vm._v("\n                Would you like a competent partner to help you develop your idea? We have many years of experience in the design of digital solutions and will be pleased to help you.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("MORE THAN JUST AESTHETICS - Design and User Experience")]), _vm._v(" "), _c('p', [_vm._v("\n                Are you convinced that an excellent user experience as well as individual design are important to your product? We visualize your ideas and always keep an eye on aesthetics, feasibility, user friendliness and accessibility. The user is at the center of the applications.\n             ")])]) : _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("ERSTE SCHRITTE - Konzeption und Beratung")]), _vm._v(" "), _c('p', [_vm._v("\n                Möchten Sie einen kompetenten Partner, welcher Ihnen hilft, Ihre Idee zu verwirklichen? Wir haben jahrelange Erfahrung bei der Entwicklung digitaler Lösungen und freuen uns Ihnen zu helfen.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("MEHR ALS NUR ÄSTHETIK - Design und User Experience")]), _vm._v(" "), _c('p', [_vm._v("\n                Sie sind davon überzeugt, dass eine exzellente Nutzererfahrung zusammen mit einem individuellen Design wichtig für Ihr Produkt ist? Wir designen Ihre Ideen und haben dabei immer ein Auge auf Ästhetik, Anwendbarkeit, Nutzerfreundlichkeit und Zugänglichkeit. Der Nutzer steht im Mittelpunkt aller Anwendungen.\n             ")])])]), _vm._v(" "), (_vm.english) ? _c('div', {
    staticClass: "headingMobile"
  }, [_c('h2', [_vm._v("Development")])]) : _c('div', {
    staticClass: "headingMobile"
  }, [_c('h2', [_vm._v("Entwicklung")])]), _vm._v(" "), _c('div', {
    ref: "dev",
    staticClass: "content"
  }, [(_vm.english) ? _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("DEVICE INDEPENDENT - Responsive Websites")]), _vm._v(" "), _c('p', [_vm._v("\n                Do you prefer a website that works on all devices and is user-friendly? Whether on a smartphone or on an extra-large screen: the user should quickly and purposefully get the desired information without having to fight with the interface.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("POWERFUL WEBSITES - Web Applications")]), _vm._v(" "), _c('p', [_vm._v("\n                Do you need tailor-made functionalities that are seamlessly integrated into the front end? We have the necessary know-how.\n                We develop web applications with solid, modern open-source frameworks. Maintainability and sustainable programming are important to us.\n                After the launch, your application should be able to be maintained, expanded and optimized quickly and cost-effectively.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("EASY TO MAINTAIN - Content Management Systems")]), _vm._v(" "), _c('p', [_vm._v("\n               You need a dynamic, multilingual website that is intuitive to use and easy to manage? We are experts in Wordpress - one of the world's most widely used open source content management systems.\n             ")])]) : _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("GERÄTEUNABHÄNGIG - Responsive Webseiten")]), _vm._v(" "), _c('p', [_vm._v("\n                Sie bevorzugen Webseiten, die auf allen Geräten funktionieren und nutzerfreundlich sind? Ob Smartphone oder großer Bildschirm: Der Nutzer sollte schnell und ohne mit dem Interface kämpfen zu müssen an seine gewünschten Informationen gelangen.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("WEBSEITEN MIT POWER - Web Applikationen")]), _vm._v(" "), _c('p', [_vm._v("\n               Sie benötigen maßgeschneiderte Funktionalitäten, die sich nahtlos integrieren? Wir haben das nötige Know-How. Wir entwickeln Web Applikationen mit modernsten Open Source Frameworks. Wartbarkeit und Nachhaltigkeit sind uns beim Programmieren sehr wichtig.\n               Nach dem Launch sollte Ihre Applikation schnell gewartet, erweitert und optimiert werden können ohne kostenintensiv zu sein.\n             ")]), _vm._v(" "), _c('h2', [_vm._v("LEICHT ZU PFLEGEN - Content Management Systeme")]), _vm._v(" "), _c('p', [_vm._v("\n               Sie benötigen eine dynamische, multilinguale Webseite, welche leicht zu nutzen und zu managen ist? Wir sind Wordpress Experten - dem weltweit meist genutzten Open Source Content Management System.\n             ")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    ref: "pwa",
    staticClass: "content"
  }, [(_vm.english) ? _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("MOBILE WEBSITES WITH SUPERPOWERS")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("MAIN ADVANTAGES")]), _vm._v(" "), _c('h3', [_vm._v("Reliable")]), _vm._v(" "), _c('p', [_vm._v("Load instantly even in uncertain network conditions. When launched from the user’s home screen, Progressive Web Apps load instantly, regardless of the network state. This eliminates the dependence on the network, ensuring an instant and reliable experience for users.")]), _vm._v(" "), _c('h3', [_vm._v("Fast")]), _vm._v(" "), _c('p', [_vm._v("Respond quickly to user interactions with silky smooth animations and no janky scrolling. 53% of users will abandon a site if it takes longer than 3 seconds to load! And once loaded, users expect them to be fast—no janky scrolling or slow-to-respond interfaces.")]), _vm._v(" "), _c('h3', [_vm._v("Engaging")]), _vm._v(" "), _c('p', [_vm._v("Progressive Web Apps are installable and live on the user's home screen, without the need for an app store. They offer an immersive full screen experience and can even re-engage users with web push notifications.")])]) : _c('div', {
    staticClass: "con"
  }, [_c('h2', [_vm._v("MOBILE WEBSEITEN MIT SUPERKRÄFTEN")]), _vm._v(" "), _c('p', [_vm._v("\n                PWAs wirken wie native Applikationen. Sie besitzen die Möglichkeit auf dem Home Screen des Smartphones gespeichert zu werden, können im Vollbild angezeigt und offline genutzt werden. Dabei bleiben es dennoch Webseiten, welche direkt im Browser Fenster erreicht werden können anstatt aus dem App Store herunter geladen zu werden.\n                Diese Eigenschaften ermöglichen eine signifikante Erhöhung der Konversionsraten im mobilen Sektor. Außerdem bekommen sie einen SEO-Boost durch Google.\n              ")]), _vm._v(" "), _c('h2', [_vm._v("VORTEILE")]), _vm._v(" "), _c('h3', [_vm._v("Zuverlässig")]), _vm._v(" "), _c('p', [_vm._v("PWAs laden sofort, wenn man sie vom Home Screen aus öffnet - selbst mit schlechten Internetverbindungen. Dies eliminiert die Abhängigkeit von der Internet Verbindung und sorgt für eine sofortige und zuverlässige Nutzererfahrung.")]), _vm._v(" "), _c('h3', [_vm._v(" Schnell")]), _vm._v(" "), _c('p', [_vm._v("PWAs antworten schnell auf Nutzerinteraktionen mit butterweichen Animationen ohne Ruckler. 53% aller Nutzer verlassen eine Seite sofort, wenn sie länger als 3 Sekunden zum laden benötigt. Auch nach dem Laden werden schnell antwortende, ruckelfreie Interfaces erwartet.")]), _vm._v(" "), _c('h3', [_vm._v("Gewinnend")]), _vm._v(" "), _c('p', [_vm._v("Progressive Web Apps sind installierbar und erscheinen wie native Apps auf dem Homescreen des Smartphones - ganz ohne App Store. Dabei starten sie wie native Apps im Vollbildmodus und können mit Nutzern sogar über Push Notifikationen interagieren.")])])])])]), _vm._v(" "), (_vm.english) ? _c('router-link', {
    staticClass: "legal",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Legal")]) : _c('router-link', {
    staticClass: "legal",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Impressum")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Möchten Sie ein neues Produkt, Unternehmen oder einen Service starten? "), _c('br'), _vm._v("\n                Möchten Sie Ihre Online Präsenz verbessern um zu zeigen, was Sie können?"), _c('br'), _vm._v("\n                Möchten Sie Ihre einzigartige Persönlichkeit und Ihr Können in Ihrem Industriezweig hervorheben?\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headingMobile"
  }, [_c('h2', [_vm._v("Design")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headingMobile"
  }, [_c('h2', [_vm._v("Progressive Web App")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                Progressive Web Apps are mobile websites — just better\n                PWAs act like native apps, with access from the home screen, full-screen viewing, and the ability to browse while offline. But they’re still websites, accessed directly in the web browser instead of an app store download.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n                By bringing the high-converting features of an app to the larger audience on mobile web, there can be a significant improvement in conversion rates. Plus, PWAs get a healthy SEO boost from Google.\n              ")])
}]}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('div', {
    staticClass: "logo",
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    attrs: {
      "width": "1039px",
      "height": "256px",
      "viewBox": "0 0 1039 256",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("LING IT")]), _vm._v(" "), _c('desc', [_vm._v("LING IT Logo")]), _vm._v(" "), _c('defs', [_c('linearGradient', {
    attrs: {
      "x1": "50.0409091%",
      "y1": "2.54931888%",
      "x2": "50.5634165%",
      "y2": "95.6643537%",
      "id": "linearGradient-1"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "12.27%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "50.8307659%",
      "y1": "97.2946503%",
      "x2": "48.9355402%",
      "y2": "4.22457485%",
      "id": "linearGradient-2"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.95",
      "offset": "25.04%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "97.9051388%",
      "y1": "49.9301877%",
      "x2": "4.53457707%",
      "y2": "51.1621959%",
      "id": "linearGradient-3"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.95",
      "offset": "10.24%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "49.0697585%",
      "y1": "2.46930084%",
      "x2": "50.6365782%",
      "y2": "95.9048399%",
      "id": "linearGradient-4"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "19.36%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "49.3048601%",
      "y1": "38.7215666%",
      "x2": "49.9770943%",
      "y2": "95.6137035%",
      "id": "linearGradient-5"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.8",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.02",
      "offset": "100%"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "x1": "38.6886982%",
      "y1": "49.6708333%",
      "x2": "95.5690355%",
      "y2": "49.6708333%",
      "id": "linearGradient-6"
    }
  }, [_c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.9",
      "offset": "0%"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "stop-color": "#FF5851",
      "stop-opacity": "0.1",
      "offset": "100%"
    }
  })], 1)], 1), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Logo",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-81.000000, -183.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "LING-IT",
      "transform": "translate(81.000000, 183.000000)"
    }
  }, [_c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "1011.79894 28.5277769 1038.64253 28.5277769 1038.64253 72.2235372 996.262907 72.2235372 996.262907 227.00129 944.670322 227.00129 944.670322 126.216927 957.216927 126.216927 957.216927 102 944.670322 102 944.670322 72.2235372 902.2907 72.2235372 902.2907 28.5277769 976 28.5277769 976 46.851846 1011.79894 46.851846"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "843.216927 28.5277769 877.897433 28.5277769 877.897433 127 861 127 861 195.439143 877.897433 195.439143 877.897433 227.00129 826.304849 227.00129 826.304849 66.4338547 843.216927 66.4338547"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M521.481477,202.720833 L521.481477,127 L493.234404,127 C493.287984,111.75176 495.788317,97.7485872 500.735476,84.9900695 C505.736801,72.0918589 512.843841,61.0802865 522.056809,51.9550219 C524.847984,49.1904177 527.812294,46.6110548 530.949748,44.2169274 L582.280907,44.2169274 L582.280907,23.9696978 C587.593536,23.3232314 593.095656,23 598.787286,23 C619.494527,23 637.656963,27.4748223 653.275137,36.424601 C668.893311,45.3743798 681.264825,59.2375547 690.39005,78.0145415 L641.429952,98.2830568 C636.867339,87.4029336 630.944806,79.59393 623.662174,74.8558119 C616.379543,70.1176937 608.087996,67.7486701 598.787286,67.7486701 C591.065941,67.7486701 584.046642,69.1964068 577.729179,72.0919234 C571.411715,74.9874401 566.015629,79.1112959 561.540759,84.4636146 C557.065889,89.8159333 553.55624,96.2649418 551.011706,103.810834 C548.467172,111.356726 547.194924,119.77992 547.194924,129.080671 C547.194924,137.503992 548.291689,145.312996 550.485253,152.507916 C552.678817,159.702836 555.969113,165.932491 560.356241,171.197066 C564.743368,176.461642 570.183325,180.541627 576.676273,183.437144 C583.169222,186.33266 590.714968,187.780397 599.313738,187.780397 C604.402806,187.780397 609.316315,187.210077 614.054413,186.069419 C618.792511,184.92876 623.047961,183.086187 626.82089,180.541642 C630.59382,177.997097 633.708634,174.706786 636.165425,170.670611 C638.622217,166.634437 640.2893,161.720906 641.166726,155.929873 L598.787286,155.929873 L598.787286,115.919297 L662.00015,115.919297 L662.00015,161.433855 L696.823447,161.433855 C696.169518,163.87149 695.428927,166.248467 694.601672,168.564792 C690.916484,178.918457 685.915234,188.087456 679.59777,196.072062 C673.280307,204.056669 665.866173,210.725032 657.355145,216.07735 C648.844118,221.429669 639.499676,225.509654 629.32154,228.317428 C619.143405,231.125201 608.438974,232.529067 597.207928,232.529067 C581.765239,232.529067 567.682771,229.98456 554.960101,224.895471 C542.237431,219.806381 531.313647,212.655439 522.188422,203.442432 C521.951412,203.203142 521.715764,202.962609 521.481477,202.720833 Z",
      "id": "Combined-Shape",
      "fill": "#424242"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M403,148.493378 L403,225.619027 L308.797077,105.653426 L308.797077,227.00129 L257.204493,227.00129 L257.204493,175.433855 L272.216927,175.433855 L272.216927,127 L257.204493,127 L257.204493,52.851846 L285.904756,52.851846 L285.904756,28.5277769 L308.797077,28.5277769 L329.584376,55 L319,55 L319,79.2169274 L348.600705,79.2169274 L403,148.493378 Z M404.085422,127 L404.085422,28.5277769 L455.414779,28.5277769 L455.414779,127 L404.085422,127 Z",
      "id": "Combined-Shape",
      "fill": "#424242"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "214.122076 55 195 55 195 123.439143 214.122076 123.439143 214.122076 227.00129 162.529491 227.00129 162.529491 28.5277769 214.122076 28.5277769"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "Combined-Shape",
      "fill": "#424242",
      "points": "21 206 21 131.433855 36.2169274 131.433855 36.2169274 83 21 83 21 28.5277769 72.5925844 28.5277769 72.5925844 183.30553 134.45104 183.30553 134.45104 227.00129 94.2857007 227.00129 94.2857007 206 21 206"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_22_",
      "fill": "url(#linearGradient-1)",
      "fill-rule": "nonzero",
      "points": "477 103 532.804224 103.507311 531.282291 263.310316"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_4_",
      "fill": "url(#linearGradient-2)",
      "fill-rule": "nonzero",
      "points": "222.537031 0 221.996537 107.017761 182 106.477267 182 0"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_21_",
      "fill": "url(#linearGradient-3)",
      "fill-rule": "nonzero",
      "points": "1026.18146 12 1026.18146 62.7319706 937 37.6329957"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_20_",
      "fill": "url(#linearGradient-4)",
      "fill-rule": "nonzero",
      "points": "808 146.704336 808.563616 12 855.9074 12 854.780167 146.704336"
    }
  }), _vm._v(" "), _c('polygon', {
    attrs: {
      "id": "XMLID_19_",
      "fill": "url(#linearGradient-5)",
      "fill-rule": "nonzero",
      "points": "391 219.367765 391.504065 102 434.853698 102.63442 433.845567 220.002185"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "XMLID_18_",
      "fill": "url(#linearGradient-6)",
      "fill-rule": "nonzero",
      "x": "0",
      "y": "195",
      "width": "109.829028",
      "height": "36.5991459"
    }
  })])])])])], 1), _vm._v(" "), _c('div', {
    ref: "rectangle",
    staticClass: "rectangle"
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('div', {
    staticClass: "fb"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/lingitio/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "fbIcon",
    attrs: {
      "width": "10px",
      "height": "20px",
      "viewBox": "0 0 10 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("fb")]), _vm._v(" "), _c('desc', [_vm._v("Facebook Ccon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-84.000000, -810.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.293314,6.47609191 L12.1283378,6.47609191 L12.1283378,4.40033119 C12.1283378,3.62078245 12.645001,3.43903954 13.0089008,3.43903954 C13.3719727,3.43903954 15.2423929,3.43903954 15.2423929,3.43903954 L15.2423929,0.0120057959 L12.1664252,0 C8.75181122,0 7.97474643,2.55599255 7.97474643,4.19167874 L7.97474643,6.47609191 L6,6.47609191 L6,10.0074519 L7.97474643,10.0074519 C7.97474643,14.5394328 7.97474643,20 7.97474643,20 L12.1283378,20 C12.1283378,20 12.1283378,14.4856137 12.1283378,10.0074519 L14.9310702,10.0074519 L15.293314,6.47609191 Z",
      "id": "fb"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "twitter"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/LING_IT",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "17px",
      "viewBox": "0 0 20 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("twitter")]), _vm._v(" "), _c('desc', [_vm._v("Twitter Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -860.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20,51.9239592 C19.2647626,52.2507764 18.4734994,52.4712259 17.6432617,52.56988 C18.4909567,52.0623998 19.1409374,51.258551 19.4474555,50.2996163 C18.6545683,50.770152 17.7768305,51.1115848 16.8418489,51.2959016 C16.09362,50.4985486 15.0270994,50 13.8469034,50 C11.5811055,50 9.74402696,51.8370785 9.74402696,54.1032824 C9.74402696,54.4244159 9.78015955,54.7374297 9.85039482,55.038264 C6.44012748,54.8669387 3.4163571,53.2336642 1.39252583,50.7510708 C1.03931957,51.3567992 0.837139435,52.0615878 0.837139435,52.8142825 C0.837139435,54.2376632 1.56141526,55.4937783 2.66244443,56.2294217 C1.99013458,56.2079045 1.3572052,56.0231817 0.80384873,55.7158517 C0.803442746,55.732903 0.803442746,55.7503603 0.803442746,55.7678176 C0.803442746,57.7555163 2.21789172,59.4135558 4.0951627,59.7911211 C3.75088809,59.8844975 3.38834419,59.9348395 3.01402675,59.9348395 C2.74932505,59.9348395 2.49233705,59.9092625 2.24184479,59.8609504 C2.76434647,61.490977 4.27947953,62.6776688 6.07474169,62.7105536 C4.67044232,63.8111767 2.90156913,64.4672472 0.978827924,64.4672472 C0.647950795,64.4672472 0.321133508,64.44776 0,64.4095975 C1.81637334,65.5743662 3.97296145,66.2531718 6.28991332,66.2531718 C13.8375657,66.2531718 17.9643952,60.001015 17.9643952,54.5786899 C17.9643952,54.4008688 17.9607413,54.2234537 17.9530276,54.0472566 C18.7544405,53.469947 19.4502974,52.7468891 20,51.9239592 Z",
      "id": "twitter"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "dribbble"
  }, [_c('a', {
    attrs: {
      "href": "https://dribbble.com/Fliebau",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "dribbble",
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("dribbble")]), _vm._v(" "), _c('desc', [_vm._v("Dribbble Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -908.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.7973201,105.986973 C19.6662469,105.344552 19.4692324,104.71184 19.2143678,104.107447 C18.9639532,103.513977 18.653261,102.942756 18.292405,102.408754 C17.9343808,101.879202 17.5237656,101.381609 17.0714819,100.92973 C16.6196029,100.477042 16.1216054,100.066022 15.5924578,99.7088068 C15.0584557,99.3467372 14.4864261,99.0372587 13.8937647,98.786035 C13.2893714,98.5315749 12.6570643,98.3341559 12.014239,98.2038917 C11.3560409,98.068773 10.67802,98 10.0008082,98 C9.3227873,98 8.6455755,98.068773 7.98656832,98.2038917 C7.34414757,98.3341559 6.71143594,98.5319794 6.10744716,98.786035 C5.5147857,99.0372587 4.94275614,99.3471418 4.40794491,99.7088068 C3.87839279,100.066022 3.38079989,100.476637 2.92892081,100.92973 C2.47663718,101.381609 2.06642645,101.879606 1.70880684,102.408754 C1.3475463,102.942756 1.0372587,103.513977 0.786844057,104.107447 C0.53076576,104.71184 0.33456043,105.344552 0.203082631,105.986973 C0.0683684554,106.644362 0,107.322383 0,107.999999 C0,108.678829 0.0683684554,109.35685 0.203082631,110.014644 C0.33456043,110.657064 0.531170307,111.289776 0.78643951,111.893765 C1.03685415,112.486426 1.3475463,113.059265 1.70840229,113.593267 C2.0660219,114.122819 2.47623264,114.619603 2.92851626,115.072291 C3.38039534,115.52417 3.87839279,115.934381 4.40754036,116.292405 C4.94235159,116.653666 5.51438115,116.963953 6.10704262,117.214368 C6.71062685,117.470446 7.34374302,117.665438 7.98616377,117.79732 C8.64517095,117.933248 9.32238275,118.001212 10.0004036,118.001212 C10.6776154,118.001212 11.3556363,117.933248 12.0138344,117.79732 C12.6570643,117.665438 13.2889668,117.470042 13.8933601,117.214368 C14.4860216,116.963953 15.0580512,116.653261 15.5920533,116.292405 C16.1216054,115.934381 16.6191983,115.524575 17.0710774,115.072291 C17.5229565,114.619603 17.9339763,114.122415 18.2920005,113.593267 C18.653261,113.059265 18.9635486,112.486426 19.2139632,111.893765 C19.4692324,111.29018 19.6658423,110.657064 19.7969156,110.014644 C19.9320343,109.356445 19.9999982,108.678425 19.9999982,107.999999 C20.0004028,107.322383 19.9324388,106.644362 19.7973201,105.986973 Z M18.5375605,107.915449 C18.4141737,107.888749 15.5240894,107.266555 12.5895049,107.635502 C12.529632,107.489461 12.4685453,107.342206 12.405436,107.194546 C12.2278398,106.776649 12.0364891,106.362393 11.8374519,105.955823 C15.2105654,104.579554 16.5799572,102.599296 16.5957346,102.575832 C17.7935985,104.029774 18.5181423,105.888263 18.5375605,107.915449 Z M15.6410035,101.59076 C15.6195625,101.623933 14.403494,103.47514 11.1800629,104.683522 C9.72005253,102.000971 8.11602338,99.8702211 7.98778196,99.7011204 C8.63343909,99.5445607 9.30660542,99.4600104 10.0004036,99.4600104 C12.1631123,99.4600104 14.1360884,100.265868 15.6410035,101.59076 Z M7.9546091,99.7079977 C7.9546091,99.7088068 7.95299091,99.7096159 7.95299091,99.7096159 C7.95299091,99.7096159 7.94368633,99.7120432 7.92790899,99.7152796 C7.93640448,99.7128523 7.94611361,99.7112341 7.9546091,99.7079977 Z M6.35624361,100.275982 C6.46992134,100.428496 8.04967766,102.569764 9.52789267,105.196892 C5.42699899,106.286338 1.86819838,106.24386 1.64246112,106.239815 C2.1974997,103.594481 3.97467499,101.401027 6.35624361,100.275982 Z M1.46001039,107.999999 C1.46001039,107.908976 1.46405586,107.819976 1.46729223,107.730166 C1.61778375,107.733403 5.83801881,107.82928 10.235041,106.513289 C10.4797919,106.992272 10.7140247,107.478942 10.9280301,107.965208 C10.8151615,107.996763 10.7026974,108.030745 10.5914469,108.067154 C5.98244212,109.556696 3.64456458,113.704113 3.64456458,113.704113 C3.64456458,113.704113 3.64780096,113.70654 3.64780096,113.708158 C2.28811825,112.194748 1.46001039,110.194262 1.46001039,107.999999 Z M10.0004036,116.541201 C7.93357265,116.541201 6.03786507,115.806544 4.56045916,114.584003 C4.6725187,114.675026 4.75180992,114.733281 4.75180992,114.733281 C4.75180992,114.733281 6.38901193,111.162748 11.4535367,109.398114 C11.4725504,109.390832 11.4915642,109.385573 11.5105779,109.379909 C12.7124872,112.502608 13.2084619,115.118005 13.3350852,115.864394 C12.3099629,116.300496 11.1832993,116.541201 10.0004036,116.541201 Z M14.7728455,115.084427 C14.6858679,114.56863 14.2307524,112.062056 13.1105615,108.983858 C15.8671453,108.542901 18.2568049,109.299 18.4327828,109.35685 C18.0525086,111.736396 16.6903986,113.789068 14.7728455,115.084427 Z",
      "id": "dribbble"
    }
  })])])])])])])]), _vm._v(" "), (_vm.menu) ? _c('div', {
    staticClass: "lineMobile"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    staticClass: "socialMobile"
  }, [_c('div', {
    ref: "fb",
    staticClass: "fb"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/lingitio/",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "fbIcon",
    attrs: {
      "width": "10px",
      "height": "20px",
      "viewBox": "0 0 10 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("fb")]), _vm._v(" "), _c('desc', [_vm._v("Facebook Ccon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-84.000000, -810.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M15.293314,6.47609191 L12.1283378,6.47609191 L12.1283378,4.40033119 C12.1283378,3.62078245 12.645001,3.43903954 13.0089008,3.43903954 C13.3719727,3.43903954 15.2423929,3.43903954 15.2423929,3.43903954 L15.2423929,0.0120057959 L12.1664252,0 C8.75181122,0 7.97474643,2.55599255 7.97474643,4.19167874 L7.97474643,6.47609191 L6,6.47609191 L6,10.0074519 L7.97474643,10.0074519 C7.97474643,14.5394328 7.97474643,20 7.97474643,20 L12.1283378,20 C12.1283378,20 12.1283378,14.4856137 12.1283378,10.0074519 L14.9310702,10.0074519 L15.293314,6.47609191 Z",
      "id": "fb"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    ref: "twitter",
    staticClass: "twitter"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/LING_IT",
      "target": "_blank"
    }
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "17px",
      "viewBox": "0 0 20 17",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("twitter")]), _vm._v(" "), _c('desc', [_vm._v("Twitter Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -860.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20,51.9239592 C19.2647626,52.2507764 18.4734994,52.4712259 17.6432617,52.56988 C18.4909567,52.0623998 19.1409374,51.258551 19.4474555,50.2996163 C18.6545683,50.770152 17.7768305,51.1115848 16.8418489,51.2959016 C16.09362,50.4985486 15.0270994,50 13.8469034,50 C11.5811055,50 9.74402696,51.8370785 9.74402696,54.1032824 C9.74402696,54.4244159 9.78015955,54.7374297 9.85039482,55.038264 C6.44012748,54.8669387 3.4163571,53.2336642 1.39252583,50.7510708 C1.03931957,51.3567992 0.837139435,52.0615878 0.837139435,52.8142825 C0.837139435,54.2376632 1.56141526,55.4937783 2.66244443,56.2294217 C1.99013458,56.2079045 1.3572052,56.0231817 0.80384873,55.7158517 C0.803442746,55.732903 0.803442746,55.7503603 0.803442746,55.7678176 C0.803442746,57.7555163 2.21789172,59.4135558 4.0951627,59.7911211 C3.75088809,59.8844975 3.38834419,59.9348395 3.01402675,59.9348395 C2.74932505,59.9348395 2.49233705,59.9092625 2.24184479,59.8609504 C2.76434647,61.490977 4.27947953,62.6776688 6.07474169,62.7105536 C4.67044232,63.8111767 2.90156913,64.4672472 0.978827924,64.4672472 C0.647950795,64.4672472 0.321133508,64.44776 0,64.4095975 C1.81637334,65.5743662 3.97296145,66.2531718 6.28991332,66.2531718 C13.8375657,66.2531718 17.9643952,60.001015 17.9643952,54.5786899 C17.9643952,54.4008688 17.9607413,54.2234537 17.9530276,54.0472566 C18.7544405,53.469947 19.4502974,52.7468891 20,51.9239592 Z",
      "id": "twitter"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    ref: "dribbble",
    staticClass: "dribbble"
  }, [_c('a', {
    attrs: {
      "href": "https://dribbble.com/Fliebau",
      "target": "_blank"
    }
  }, [_c('svg', {
    staticClass: "dribbble",
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 20 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("dribbble")]), _vm._v(" "), _c('desc', [_vm._v("Dribbble Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-78.000000, -908.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Sidebar",
      "transform": "translate(76.000000, 146.000000)",
      "fill": "#D0D0D0",
      "fill-rule": "nonzero"
    }
  }, [_c('g', {
    attrs: {
      "id": "Social",
      "transform": "translate(2.000000, 664.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.7973201,105.986973 C19.6662469,105.344552 19.4692324,104.71184 19.2143678,104.107447 C18.9639532,103.513977 18.653261,102.942756 18.292405,102.408754 C17.9343808,101.879202 17.5237656,101.381609 17.0714819,100.92973 C16.6196029,100.477042 16.1216054,100.066022 15.5924578,99.7088068 C15.0584557,99.3467372 14.4864261,99.0372587 13.8937647,98.786035 C13.2893714,98.5315749 12.6570643,98.3341559 12.014239,98.2038917 C11.3560409,98.068773 10.67802,98 10.0008082,98 C9.3227873,98 8.6455755,98.068773 7.98656832,98.2038917 C7.34414757,98.3341559 6.71143594,98.5319794 6.10744716,98.786035 C5.5147857,99.0372587 4.94275614,99.3471418 4.40794491,99.7088068 C3.87839279,100.066022 3.38079989,100.476637 2.92892081,100.92973 C2.47663718,101.381609 2.06642645,101.879606 1.70880684,102.408754 C1.3475463,102.942756 1.0372587,103.513977 0.786844057,104.107447 C0.53076576,104.71184 0.33456043,105.344552 0.203082631,105.986973 C0.0683684554,106.644362 0,107.322383 0,107.999999 C0,108.678829 0.0683684554,109.35685 0.203082631,110.014644 C0.33456043,110.657064 0.531170307,111.289776 0.78643951,111.893765 C1.03685415,112.486426 1.3475463,113.059265 1.70840229,113.593267 C2.0660219,114.122819 2.47623264,114.619603 2.92851626,115.072291 C3.38039534,115.52417 3.87839279,115.934381 4.40754036,116.292405 C4.94235159,116.653666 5.51438115,116.963953 6.10704262,117.214368 C6.71062685,117.470446 7.34374302,117.665438 7.98616377,117.79732 C8.64517095,117.933248 9.32238275,118.001212 10.0004036,118.001212 C10.6776154,118.001212 11.3556363,117.933248 12.0138344,117.79732 C12.6570643,117.665438 13.2889668,117.470042 13.8933601,117.214368 C14.4860216,116.963953 15.0580512,116.653261 15.5920533,116.292405 C16.1216054,115.934381 16.6191983,115.524575 17.0710774,115.072291 C17.5229565,114.619603 17.9339763,114.122415 18.2920005,113.593267 C18.653261,113.059265 18.9635486,112.486426 19.2139632,111.893765 C19.4692324,111.29018 19.6658423,110.657064 19.7969156,110.014644 C19.9320343,109.356445 19.9999982,108.678425 19.9999982,107.999999 C20.0004028,107.322383 19.9324388,106.644362 19.7973201,105.986973 Z M18.5375605,107.915449 C18.4141737,107.888749 15.5240894,107.266555 12.5895049,107.635502 C12.529632,107.489461 12.4685453,107.342206 12.405436,107.194546 C12.2278398,106.776649 12.0364891,106.362393 11.8374519,105.955823 C15.2105654,104.579554 16.5799572,102.599296 16.5957346,102.575832 C17.7935985,104.029774 18.5181423,105.888263 18.5375605,107.915449 Z M15.6410035,101.59076 C15.6195625,101.623933 14.403494,103.47514 11.1800629,104.683522 C9.72005253,102.000971 8.11602338,99.8702211 7.98778196,99.7011204 C8.63343909,99.5445607 9.30660542,99.4600104 10.0004036,99.4600104 C12.1631123,99.4600104 14.1360884,100.265868 15.6410035,101.59076 Z M7.9546091,99.7079977 C7.9546091,99.7088068 7.95299091,99.7096159 7.95299091,99.7096159 C7.95299091,99.7096159 7.94368633,99.7120432 7.92790899,99.7152796 C7.93640448,99.7128523 7.94611361,99.7112341 7.9546091,99.7079977 Z M6.35624361,100.275982 C6.46992134,100.428496 8.04967766,102.569764 9.52789267,105.196892 C5.42699899,106.286338 1.86819838,106.24386 1.64246112,106.239815 C2.1974997,103.594481 3.97467499,101.401027 6.35624361,100.275982 Z M1.46001039,107.999999 C1.46001039,107.908976 1.46405586,107.819976 1.46729223,107.730166 C1.61778375,107.733403 5.83801881,107.82928 10.235041,106.513289 C10.4797919,106.992272 10.7140247,107.478942 10.9280301,107.965208 C10.8151615,107.996763 10.7026974,108.030745 10.5914469,108.067154 C5.98244212,109.556696 3.64456458,113.704113 3.64456458,113.704113 C3.64456458,113.704113 3.64780096,113.70654 3.64780096,113.708158 C2.28811825,112.194748 1.46001039,110.194262 1.46001039,107.999999 Z M10.0004036,116.541201 C7.93357265,116.541201 6.03786507,115.806544 4.56045916,114.584003 C4.6725187,114.675026 4.75180992,114.733281 4.75180992,114.733281 C4.75180992,114.733281 6.38901193,111.162748 11.4535367,109.398114 C11.4725504,109.390832 11.4915642,109.385573 11.5105779,109.379909 C12.7124872,112.502608 13.2084619,115.118005 13.3350852,115.864394 C12.3099629,116.300496 11.1832993,116.541201 10.0004036,116.541201 Z M14.7728455,115.084427 C14.6858679,114.56863 14.2307524,112.062056 13.1105615,108.983858 C15.8671453,108.542901 18.2568049,109.299 18.4327828,109.35685 C18.0525086,111.736396 16.6903986,113.789068 14.7728455,115.084427 Z",
      "id": "dribbble"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "menuButtonMobile",
    class: {
      activeM: _vm.menu
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menuButton"
  }, [_c('span', {
    ref: "line1",
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    ref: "line2",
    staticClass: "line"
  }), _vm._v(" "), _c('span', {
    ref: "line3",
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    ref: "clicker",
    staticClass: "clicker",
    on: {
      "click": _vm.workMenuClicked
    }
  }), _vm._v(" "), _c('div', {
    ref: "workNavi",
    staticClass: "workNavigation"
  }, [_c('ul', [_c('li', {
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.workLinkClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "lang",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "navigation"
  }, [_c('ul', {
    ref: "navi"
  }, [_c('li', {
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "lang",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menu),
      expression: "menu"
    }],
    ref: "menu",
    staticClass: "navigationMobile"
  }, [_c('ul', [_c('li', {
    ref: "link1",
    attrs: {
      "id": "home"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('span', [_vm._v("Home")])])], 1), _vm._v(" "), _c('li', {
    ref: "link2",
    attrs: {
      "id": "work"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Work")])]) : _c('router-link', {
    attrs: {
      "to": "/work"
    }
  }, [_c('span', [_vm._v("Projekte")])])], 1), _vm._v(" "), _c('li', {
    ref: "link3",
    attrs: {
      "id": "about"
    },
    on: {
      "click": _vm.menuClicked
    }
  }, [(_vm.english) ? _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("About us")])]) : _c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_c('span', [_vm._v("Über uns")])])], 1)]), _vm._v(" "), _c('div', {
    ref: "language",
    staticClass: "lang"
  }, [_c('div', {
    staticClass: "en",
    on: {
      "click": _vm.toggleEn
    }
  }, [_c('p', {
    class: {
      active: _vm.english
    }
  }, [_vm._v("EN")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "de",
    on: {
      "click": _vm.toggleDe
    }
  }, [_c('p', {
    class: {
      active: !_vm.english
    }
  }, [_vm._v("DE")])])]), _vm._v(" "), (_vm.english) ? _c('router-link', {
    staticClass: "legalLink",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Legal")]) : _c('router-link', {
    staticClass: "legalLink",
    attrs: {
      "to": "legal"
    }
  }, [_vm._v("Impressum")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "appear": "",
      "duration": 900
    },
    on: {
      "enter": _vm.enter,
      "after-enter": _vm.afterEnter,
      "leave": _vm.leave
    }
  }, [_c('router-view', {
    ref: "view"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lineBreaker"
  }, [_c('p', [_vm._v("|")])])
}]}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homeContent"
  }, [_c('div', {
    staticClass: "rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.english) ? _c('h1', {
    ref: "object1"
  }, [_vm._v("We help to let your website become "), _c('span', [_vm._v("reality")])]) : _c('h1', {
    ref: "object1"
  }, [_vm._v("Wir lassen Ihre Webseite "), _c('span', [_vm._v("Wirklichkeit")]), _vm._v(" werden")]), _vm._v(" "), (_vm.english) ? _c('div', {
    ref: "object2"
  }, [_c('p', {
    staticClass: "firstP"
  }, [_vm._v("We at LING IT love to push boundaries to create unique and innovative websites. Our goal is to connect companies with people through tailor made web experiences.")]), _vm._v(" "), _c('p', [_vm._v("We use design, creativity and cutting edge technologies to maximize engagement. Every detail matters.")])]) : _c('div', {
    ref: "object2"
  }, [_c('p', {
    staticClass: "firstP"
  }, [_vm._v("Wir bei LING IT lieben es Technologie und Design bis an die Grenzen auszureizen um kreative, einzigartige und innovative Webserfahrungen zu kreieren.")]), _vm._v(" "), _c('p', [_vm._v("Um Unternehmen ihren Kunden näher zu bringen, verwenden wir Design, Kreativität und modernste Technologien. Jedes Detail zählt.")])])]), _vm._v(" "), _c('div', {
    ref: "object3",
    staticClass: "contactData"
  }, [_c('div', {
    staticClass: "address"
  }, [(_vm.english) ? _c('h3', [_vm._v("Address")]) : _c('h3', [_vm._v("Adresse")]), _vm._v(" "), _c('p', [_vm._v("Mansfelder Straße 56")]), _vm._v(" "), _c('p', [_vm._v("06108 Halle")])]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [(_vm.english) ? _c('h3', [_vm._v("Contact")]) : _c('h3', [_vm._v("Kontakt")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    ref: "object4"
  }, [_c('div', {
    staticClass: "homeBG"
  }, [_c('svg', {
    attrs: {
      "width": "674px",
      "height": "216px",
      "viewBox": "0 0 674 216",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("HOME")]), _vm._v(" "), _c('desc', [_vm._v("Home Background")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-68.000000, -178.000000)",
      "opacity": "0.300000012"
    }
  }, [_c('path', {
    attrs: {
      "d": "M68.76,182.94 L122.7,182.94 L122.7,258.92 L155.76,258.92 L155.76,182.94 L209.7,182.94 L209.7,390 L155.76,390 L155.76,304.74 L122.7,304.74 L122.7,390 L68.76,390 L68.76,182.94 Z M284.81,286.47 C284.81,300.39007 285.003331,311.941621 285.39,321.125 C285.776669,330.308379 286.598327,337.60664 287.855,343.02 C289.111673,348.43336 290.948321,352.203323 293.365,354.33 C295.781679,356.456677 299.01998,357.52 303.08,357.52 C307.14002,357.52 310.378321,356.456677 312.795,354.33 C315.211679,352.203323 317.048327,348.43336 318.305,343.02 C319.561673,337.60664 320.383331,330.308379 320.77,321.125 C321.156669,311.941621 321.35,300.39007 321.35,286.47 C321.35,272.54993 321.156669,260.998379 320.77,251.815 C320.383331,242.631621 319.561673,235.33336 318.305,229.92 C317.048327,224.50664 315.211679,220.736677 312.795,218.61 C310.378321,216.483323 307.14002,215.42 303.08,215.42 C299.01998,215.42 295.781679,216.483323 293.365,218.61 C290.948321,220.736677 289.111673,224.50664 287.855,229.92 C286.598327,235.33336 285.776669,242.631621 285.39,251.815 C285.003331,260.998379 284.81,272.54993 284.81,286.47 Z M229.13,286.47 C229.13,267.13657 230.386654,250.655068 232.9,237.025 C235.413346,223.394932 239.569971,212.278376 245.37,203.675 C251.170029,195.071624 258.806619,188.788353 268.28,184.825 C277.753381,180.861647 289.353265,178.88 303.08,178.88 C316.806735,178.88 328.406619,180.861647 337.88,184.825 C347.353381,188.788353 354.989971,195.071624 360.79,203.675 C366.590029,212.278376 370.746654,223.394932 373.26,237.025 C375.773346,250.655068 377.03,267.13657 377.03,286.47 C377.03,305.80343 375.773346,322.284932 373.26,335.915 C370.746654,349.545068 366.590029,360.661624 360.79,369.265 C354.989971,377.868376 347.353381,384.006648 337.88,387.68 C328.406619,391.353352 316.806735,393.19 303.08,393.19 C289.353265,393.19 277.753381,391.353352 268.28,387.68 C258.806619,384.006648 251.170029,377.868376 245.37,369.265 C239.569971,360.661624 235.413346,349.545068 232.9,335.915 C230.386654,322.284932 229.13,305.80343 229.13,286.47 Z M394.43,182.94 L471.57,182.94 L493.32,305.61 L493.9,305.61 L515.65,182.94 L592.79,182.94 L592.79,390 L542.33,390 L542.33,235.72 L541.75,235.72 L513.04,390 L474.18,390 L445.47,235.72 L444.89,235.72 L444.89,390 L394.43,390 L394.43,182.94 Z M616.28,182.94 L738.95,182.94 L738.95,227.02 L670.22,227.02 L670.22,262.4 L734.6,262.4 L734.6,304.74 L670.22,304.74 L670.22,345.92 L741.56,345.92 L741.56,390 L616.28,390 L616.28,182.94 Z",
      "id": "HOME",
      "fill": "#F4F5F5"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "scrollAnimation"
  }, [_c('svg', {
    attrs: {
      "width": "13px",
      "height": "21px",
      "viewBox": "0 0 13 21",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Scroll")]), _vm._v(" "), _c('desc', [_vm._v("Scroll Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Landing-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-394.000000, -487.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "scroll",
      "transform": "translate(394.000000, 487.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M6.5,0.5 C3.1862915,0.5 0.5,3.1862915 0.5,6.5 L0.5,14.5 C0.5,17.8137085 3.1862915,20.5 6.5,20.5 C9.8137085,20.5 12.5,17.8137085 12.5,14.5 L12.5,6.5 C12.5,3.1862915 9.8137085,0.5 6.5,0.5 Z",
      "id": "mouse",
      "stroke": "#D0D0D0"
    }
  }), _vm._v(" "), _c('circle', {
    ref: "mouseWheel",
    attrs: {
      "id": "mouse-wheel",
      "fill": "#D0D0D0",
      "cx": "6.5",
      "cy": "8.5",
      "r": "1.5"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "mailto: info@lingit.io"
    }
  }, [_c('p', [_vm._v("info@lingit.io")])])
}]}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "object4",
    staticClass: "workContent"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    ref: "object1",
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "category"
  }, [_c('p', [_vm._v(_vm._s(_vm.projects[_vm.pNumber].category))])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.projects[_vm.pNumber].title))])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [(_vm.english) ? _c('p', {
    ref: "object2"
  }, [_vm._v(_vm._s(_vm.projects[_vm.pNumber].enContent))]) : _c('p', {
    ref: "object2"
  }, [_vm._v(_vm._s(_vm.projects[_vm.pNumber].deContent))]), _vm._v(" "), (_vm.english) ? _c('a', {
    ref: "object3",
    attrs: {
      "href": _vm.projects[_vm.pNumber].url,
      "target": "_blank"
    }
  }, [_vm._v("View Project")]) : _c('a', {
    ref: "object3",
    attrs: {
      "href": _vm.projects[_vm.pNumber].url,
      "target": "_blank"
    }
  }, [_vm._v("Zur Seite")])]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v("0" + _vm._s(_vm.pNumber + 1) + "/03")])]), _vm._v(" "), _c('div', {
    staticClass: "workBG"
  }, [_c('svg', {
    attrs: {
      "width": "299px",
      "height": "90px",
      "viewBox": "0 0 299 90",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("WORK")]), _vm._v(" "), _c('desc', [_vm._v("Work Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-58.000000, -245.000000)",
      "opacity": "0.299999982"
    }
  }, [_c('path', {
    attrs: {
      "d": "M94.6,247.32 L114.76,247.32 L123.52,306.6 L123.76,306.6 L129.76,247.32 L151.36,247.32 L136.72,333 L112.24,333 L104.8,275.4 L104.56,275.4 L97.12,333 L72.64,333 L58,247.32 L79.6,247.32 L86.32,306.6 L86.56,306.6 L94.6,247.32 Z M177.16,290.16 C177.16,295.920029 177.239999,300.699981 177.4,304.5 C177.560001,308.300019 177.899997,311.319989 178.42,313.56 C178.940003,315.800011 179.699995,317.359996 180.7,318.24 C181.700005,319.120004 183.039992,319.56 184.72,319.56 C186.400008,319.56 187.739995,319.120004 188.74,318.24 C189.740005,317.359996 190.499997,315.800011 191.02,313.56 C191.540003,311.319989 191.879999,308.300019 192.04,304.5 C192.200001,300.699981 192.28,295.920029 192.28,290.16 C192.28,284.399971 192.200001,279.620019 192.04,275.82 C191.879999,272.019981 191.540003,269.000011 191.02,266.76 C190.499997,264.519989 189.740005,262.960004 188.74,262.08 C187.739995,261.199996 186.400008,260.76 184.72,260.76 C183.039992,260.76 181.700005,261.199996 180.7,262.08 C179.699995,262.960004 178.940003,264.519989 178.42,266.76 C177.899997,269.000011 177.560001,272.019981 177.4,275.82 C177.239999,279.620019 177.16,284.399971 177.16,290.16 Z M154.12,290.16 C154.12,282.15996 154.639995,275.340028 155.68,269.7 C156.720005,264.059972 158.439988,259.460018 160.84,255.9 C163.240012,252.339982 166.39998,249.740008 170.32,248.1 C174.24002,246.459992 179.039972,245.64 184.72,245.64 C190.400028,245.64 195.19998,246.459992 199.12,248.1 C203.04002,249.740008 206.199988,252.339982 208.6,255.9 C211.000012,259.460018 212.719995,264.059972 213.76,269.7 C214.800005,275.340028 215.32,282.15996 215.32,290.16 C215.32,298.16004 214.800005,304.979972 213.76,310.62 C212.719995,316.260028 211.000012,320.859982 208.6,324.42 C206.199988,327.980018 203.04002,330.519992 199.12,332.04 C195.19998,333.560008 190.400028,334.32 184.72,334.32 C179.039972,334.32 174.24002,333.560008 170.32,332.04 C166.39998,330.519992 163.240012,327.980018 160.84,324.42 C158.439988,320.859982 156.720005,316.260028 155.68,310.62 C154.639995,304.979972 154.12,298.16004 154.12,290.16 Z M245.68,283.56 L250.12,283.56 C253.320016,283.56 255.679992,282.620009 257.2,280.74 C258.720008,278.859991 259.48,276.400015 259.48,273.36 C259.48,269.759982 258.740007,267.200008 257.26,265.68 C255.779993,264.159992 253.360017,263.4 250,263.4 L245.68,263.4 L245.68,283.56 Z M223.36,247.32 L258.28,247.32 C262.520021,247.32 266.139985,247.879994 269.14,249 C272.140015,250.120006 274.579991,251.69999 276.46,253.74 C278.340009,255.78001 279.699996,258.199986 280.54,261 C281.380004,263.800014 281.8,266.839984 281.8,270.12 C281.8,275.880029 280.640012,280.519982 278.32,284.04 C275.999988,287.560018 272.280026,289.719996 267.16,290.52 L267.16,290.76 C272.520027,291.240002 276.19999,293.119984 278.2,296.4 C280.20001,299.680016 281.2,304.199971 281.2,309.96 L281.2,320.76 C281.2,321.960006 281.24,323.099995 281.32,324.18 C281.4,325.260005 281.519999,326.239996 281.68,327.12 C281.840001,328.000004 282.039999,328.679998 282.28,329.16 C282.600002,329.640002 282.919998,330.099998 283.24,330.54 C283.560002,330.980002 284.079996,331.399998 284.8,331.8 L284.8,333 L261.04,333 C260.479997,331.879994 260.060001,330.560008 259.78,329.04 C259.499999,327.519992 259.300001,326.000008 259.18,324.48 C259.059999,322.959992 258.98,321.500007 258.94,320.1 C258.9,318.699993 258.88,317.560004 258.88,316.68 L258.88,310.92 C258.88,308.519988 258.760001,306.520008 258.52,304.92 C258.279999,303.319992 257.860003,302.060005 257.26,301.14 C256.659997,300.219995 255.900005,299.580002 254.98,299.22 C254.059995,298.859998 252.920007,298.68 251.56,298.68 L245.68,298.68 L245.68,333 L223.36,333 L223.36,247.32 Z M291.4,247.32 L313.72,247.32 L313.72,280.2 L313.96,280.2 L330.52,247.32 L354.28,247.32 L332.68,284.76 L356.92,333 L331.48,333 L318.4,303.12 L313.72,310.32 L313.72,333 L291.4,333 L291.4,247.32 Z",
      "id": "WORK",
      "fill": "#F0F0F0"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "imageContainer"
  }, [_c('div', {
    staticClass: "blendContainer"
  }, [_c('div', {
    ref: "blend1",
    staticClass: "blendCon1"
  }), _vm._v(" "), _c('div', {
    ref: "blend2",
    staticClass: "blendCon2"
  }), _vm._v(" "), _c('div', {
    ref: "blend3",
    staticClass: "blendCon3"
  }), _vm._v(" "), _c('div', {
    ref: "blend4",
    staticClass: "blendCon4"
  }), _vm._v(" "), _c('div', {
    ref: "blend5",
    staticClass: "blendCon5"
  })]), _vm._v(" "), (_vm.pNumber === 0) ? _c('div', {
    staticClass: "case1"
  }) : _vm._e(), _vm._v(" "), (_vm.pNumber === 1) ? _c('div', {
    staticClass: "case2"
  }) : _vm._e(), _vm._v(" "), (_vm.pNumber === 2) ? _c('div', {
    staticClass: "case3"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "count"
  }, [_c('p', {
    class: {
      active: _vm.pNumber === 0
    }
  }, [_vm._v("01")]), _vm._v(" "), _c('p', {
    class: {
      active: _vm.pNumber === 1
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('p', {
    class: {
      active: _vm.pNumber === 2
    }
  }, [_vm._v("03")])]), _vm._v(" "), _c('div', {
    staticClass: "navi"
  }, [_c('div', {
    staticClass: "prev",
    on: {
      "click": _vm.prev
    }
  }, [_c('svg', {
    attrs: {
      "width": "10px",
      "height": "9px",
      "viewBox": "0 0 10 9",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Arrow Left")]), _vm._v(" "), _c('desc', [_vm._v("Left Arrow Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-663.000000, -505.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Work-Nav",
      "transform": "translate(663.000000, 502.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.5,6.5355625 L1.707,6.5355625 L4.389,3.8535625 C4.58425,3.6583125 4.58425,3.3416875 4.389125,3.1464375 C4.193875,2.9511875 3.877125,2.9511875 3.681875,3.1464375 L0.1465,6.6819375 C0.12325,6.7051875 0.1025,6.7308125 0.08425,6.7581875 C0.075875,6.7708125 0.07,6.7844375 0.062875,6.7975625 C0.0545,6.8130625 0.045125,6.8278125 0.038375,6.8441875 C0.031375,6.8610625 0.027375,6.8786875 0.02225,6.8961875 C0.01825,6.9100625 0.012875,6.9233125 0.01,6.9375625 C0.0035,6.9699375 0,7.0026875 0,7.0355625 C0,7.0359375 0.000125,7.0361875 0.000125,7.0365625 C0.000125,7.0689375 0.0035,7.1014375 0.009875,7.1333125 C0.012875,7.1484375 0.0185,7.1623125 0.022875,7.1769375 C0.02775,7.1935625 0.031625,7.2104375 0.03825,7.2265625 C0.0455,7.2439375 0.05525,7.2596875 0.06425,7.2760625 C0.071,7.2883125 0.07625,7.3008125 0.084125,7.3125625 C0.1025,7.3401875 0.123375,7.3659375 0.14675,7.3893125 L3.682,10.9244375 C3.87725,11.1196875 4.193875,11.1196875 4.389125,10.9245625 C4.584375,10.7293125 4.584375,10.4125625 4.389125,10.2173125 L1.707125,7.5355625 L9.5,7.5355625 C9.776125,7.5355625 10,7.3116875 10,7.0355625 C10,6.7594375 9.776125,6.5355625 9.5,6.5355625 Z",
      "id": "Arrow-Left"
    }
  })])])]), _vm._v(" "), (_vm.english) ? _c('p', [_vm._v("Prev")]) : _c('p', [_vm._v("Zurück")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "next",
    on: {
      "click": _vm.next
    }
  }, [(_vm.english) ? _c('p', [_vm._v("Next")]) : _c('p', [_vm._v("Vor")]), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "10px",
      "height": "9px",
      "viewBox": "0 0 10 9",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Arrow Right")]), _vm._v(" "), _c('desc', [_vm._v("Right Arrow Icon")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Work-Page",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(-753.000000, -505.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Work-Nav",
      "transform": "translate(663.000000, 502.000000)",
      "fill": "#FFFFFF",
      "fill-rule": "nonzero"
    }
  }, [_c('path', {
    attrs: {
      "d": "M99.5,6.5355625 L91.707,6.5355625 L94.389,3.8535625 C94.58425,3.6583125 94.58425,3.3416875 94.389125,3.1464375 C94.193875,2.9511875 93.877125,2.9511875 93.681875,3.1464375 L90.1465,6.6819375 C90.12325,6.7051875 90.1025,6.7308125 90.08425,6.7581875 C90.075875,6.7708125 90.07,6.7844375 90.062875,6.7975625 C90.0545,6.8130625 90.045125,6.8278125 90.038375,6.8441875 C90.031375,6.8610625 90.027375,6.8786875 90.02225,6.8961875 C90.01825,6.9100625 90.012875,6.9233125 90.01,6.9375625 C90.0035,6.9699375 90,7.0026875 90,7.0355625 C90,7.0359375 90.000125,7.0361875 90.000125,7.0365625 C90.000125,7.0689375 90.0035,7.1014375 90.009875,7.1333125 C90.012875,7.1484375 90.0185,7.1623125 90.022875,7.1769375 C90.02775,7.1935625 90.031625,7.2104375 90.03825,7.2265625 C90.0455,7.2439375 90.05525,7.2596875 90.06425,7.2760625 C90.071,7.2883125 90.07625,7.3008125 90.084125,7.3125625 C90.1025,7.3401875 90.123375,7.3659375 90.14675,7.3893125 L93.682,10.9244375 C93.87725,11.1196875 94.193875,11.1196875 94.389125,10.9245625 C94.584375,10.7293125 94.584375,10.4125625 94.389125,10.2173125 L91.707125,7.5355625 L99.5,7.5355625 C99.776125,7.5355625 100,7.3116875 100,7.0355625 C100,6.7594375 99.776125,6.5355625 99.5,6.5355625 Z",
      "id": "Arrow-Right",
      "transform": "translate(95.000000, 7.035445) scale(-1, 1) translate(-95.000000, -7.035445) "
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legalWrapper"
  }, [_c('div', {
    ref: "object1"
  }, [_c('h3', [_vm._v("Legal Disclosure")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    ref: "object2"
  }, [_c('h3', [_vm._v("Represented by")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    ref: "object3"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    ref: "object4"
  }, [_c('h3', [_vm._v("Disclaimer")]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Information in accordance with section 5 TMG\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      LiWiNg GbR\n      "), _c('br'), _vm._v("\n      Mansfelder Str. 56\n      "), _c('br'), _vm._v("\n      06108 Halle\n      "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Falco Liebau,\n      "), _c('br'), _vm._v("\n      Minh Duc Nguyen\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      Personally liable partner\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      Falco Liebau,\n      "), _c('br'), _vm._v("\n      Minh Duc Nguyen"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      E-Mail: "), _c('a', {
    attrs: {
      "href": "mailto:info@lingit.io"
    }
  }, [_vm._v("info@lingit.io")]), _vm._v(" "), _c('br'), _vm._v("\n      Website: "), _c('a', {
    attrs: {
      "href": "https://lingit.io",
      "target": "_blank"
    }
  }, [_vm._v("https://lingit.io")]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Accountability for content\n      "), _c('br'), _vm._v("\n      The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents' accuracy, completeness or topicality.\n      According to statutory provisions, we are furthermore responsible for our own content on these web pages. In this context, please note that we are\n      accordingly not obliged to monitor merely the transmitted or saved information of third parties, or investigate circumstances pointing to illegal\n      activity. Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this as per §§\n      8 to 10 of the Telemedia Act (TMG).\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      Accountability for links\n      "), _c('br'), _vm._v("\n      Responsibility for the content of external links (to web pages of third parties) lies solely with the operators of the linked pages. No violations\n      were evident to us at the time of linking. Should any legal infringement become known to us, we will remove the respective link immediately.\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n      Copyright\n      "), _c('br'), _vm._v("\n      Our web pages and their contents are subject to German copyright law. Unless expressly permitted by law (§ 44a et seq. of the copyright law),\n      every form of utilizing, reproducing or processing works subject to copyright protection on our web pages requires the prior consent of the respective\n      owner of the rights. Individual reproductions of a work are allowed only for private use, so must not serve either directly or indirectly for earnings.\n      Unauthorized utilization of copyrighted works is punishable (§ 106 of the copyright law).\n      "), _c('br'), _vm._v(" "), _c('br')])
}]}

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.7df10f1c2f50cfd8e8e0.js